import React from "react";
import { motion, useReducedMotion } from "framer-motion";
interface FadeUpProps {
  children: React.ReactNode;
  className?: string;
}
export function FadeUp({
  children,
  className
}: FadeUpProps) {
  const reduce = useReducedMotion();
  return <motion.div className={className} initial={{
    opacity: 0,
    y: reduce ? 0 : 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: "-60px"
  }} transition={{
    duration: 0.3,
    ease: [0.23, 1, 0.32, 1]
  }} data-id="element-67" data-mp="rfsthylxvzgo">
      {children}
    </motion.div>;
}